<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <div>
          <div class="section-title">{{ $t("voucher") }} {{ $t("codes") }}</div>
          <div class="section-subTitle my-2">{{ $t("view") }} {{ $t("all") }} {{ $t("voucher") }}
            {{ $t("codes") }}</div>
        </div>
        <div class="ml-1">
          <b-form-input v-debounce:500="onSearchVoucherCode" v-model="searchValue" v-on:search="onSearchVoucherCode"
            type="search" :placeholder="$tc('searchs')"></b-form-input>
        </div>
      </div>
      <div class="d-flex">
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex"
              @click="onDropDownChangeValue(list.name)" href="#">{{ list.name }}</b-dropdown-item>
          </b-dropdown>
        </div>

        <div style="cursor: pointer;" v-if="vocuerList && vocuerList.length > 0"
          class="d-flex justify-content-end mt-2">
          <div>{{ $t("download") }} as:</div>

          <a v-if="vocuerList.length > 0" @click="getVoucherList('Y')" target="_blank" title="Download as Excel"
            download>
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th>{{ $t("voucher") }}</th>
            <th>{{ $t("voucher") }} {{ $t("code") }}</th>
            <th>{{ $t("voucher") }} {{ $t("Redeemed") }}</th>
            <th>ticket Count</th>
            <th>Fnb Count</th>
            <th>{{ $t("voucher") }} {{ $t("Expired At") }}</th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="(voucherItem, voucherIndex) in vocuerList" :key="voucherIndex" class="light_grey_back">
            <td>{{ voucherItem.offer_title }}</td>
            <td>{{ voucherItem.voucher_code }}</td>
            <td>{{ (voucherItem.ticket_transaction_count +
              parseFloat(voucherItem.fnb_transaction_count ? voucherItem.fnb_transaction_count : 0)) || 0 }}</td>

            <td>{{ voucherItem.ticket_transaction_count }}</td>
            <td>{{ voucherItem.fnb_transaction_count }}</td>

            <td>{{ voucherItem.offer_end_date_time }}</td>

          </tr>
        </tbody>
      </table>
      <b-pagination v-if="vocuerList.length > 0" v-model="currentPage" :total-rows="rows"
        @change="onChangePagination($event)" :per-page="perPage" aria-controls="my-table"></b-pagination>
    </div>
  </div>

</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
export default {
  data() {
    return {

      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      vocuerList: [],
      voucher_title: null,
      offer_voucher_id: null,
      gridView: false,
      listView: true,
      excelPath: "",
      searchValue: "",
    };
  },
  mounted() {

    this.offer_voucher_id = this.$route.params.os_id;
    console.log("offer_voucher_id", this.offer_voucher_id)
    if (this.offer_voucher_id) {
      this.getVoucherList();
    } else {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getviewingnumber();
  },
  methods: {
    onSearchVoucherCode() {
      this.currentPage = 1;
      this.getVoucherList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getVoucherList();
      } else {
        this.currentPage = event;
        this.getVoucherList();
      }
    },
    getVoucherList: function (isExcel = "N") {
      let payload = {
        isExcel: isExcel,
        limit: this.perPage,
        currentPage: this.currentPage,
        offer_voucher_id: this.offer_voucher_id,
        searchValue: this.searchValue || null,
      };
      MarketingService.getVoucherCodesList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.vocuerList = data.Records;
              console.log("VoucherList", this.vocuerList)
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                if (data.totalRows) {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              }
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/viewVoucherCodesNew.vue